import { Link } from "react-router-dom";
import { Github, Mail } from "lucide-react";
import { investigateLinks, mainLinks } from "../config/navigation";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-800 mt-auto" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand Column */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-display text-2xl font-bold text-white">FLI</span>
              <span className="block font-mono text-xs text-gray-500 uppercase tracking-wider mt-1">
                Factual Labelling Initiative
              </span>
            </Link>
            <p className="font-mono text-xs text-gray-600 leading-relaxed">
              Exposing the true cost of consumer goods through transparent supply chain analysis.
            </p>
          </div>

          {/* Investigate Column */}
          <div>
            <h3 className="font-mono text-xs font-bold uppercase tracking-widest text-red-500 mb-4">
              Investigate
            </h3>
            <ul className="space-y-2">
              {investigateLinks.map((link) => {
                const Icon = link.icon;
                return (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="flex items-center gap-2 font-mono text-sm text-gray-400 hover:text-white transition-colors"
                    >
                      <Icon className="w-4 h-4" />
                      {link.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Navigation Column */}
          <div>
            <h3 className="font-mono text-xs font-bold uppercase tracking-widest text-gray-500 mb-4">
              Navigation
            </h3>
            <ul className="space-y-2">
              {mainLinks.map((link) => {
                const Icon = link.icon;
                return (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="flex items-center gap-2 font-mono text-sm text-gray-400 hover:text-white transition-colors"
                    >
                      <Icon className="w-4 h-4" />
                      {link.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Connect Column */}
          <div>
            <h3 className="font-mono text-xs font-bold uppercase tracking-widest text-gray-500 mb-4">
              Connect
            </h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://github.com/fli-project"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 font-mono text-sm text-gray-400 hover:text-white transition-colors"
                >
                  <Github className="w-4 h-4" />
                  GitHub
                </a>
              </li>
              <li>
                <a
                  href="mailto:contact@fli.org"
                  className="flex items-center gap-2 font-mono text-sm text-gray-400 hover:text-white transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  Contact
                </a>
              </li>
            </ul>

          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-mono text-xs text-gray-600">
            © {currentYear} Factual Labelling Initiative.
          </p>
          
          <div className="flex items-center gap-4">
            <span className="font-mono text-xs text-gray-700">
              v4.1 MVP
            </span>
            <span className="w-px h-4 bg-gray-800" />
            <span className="font-mono text-xs text-gray-700">
              {new Date().toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
